import { faCheck, faFileInvoice, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useCallback, useEffect, useMemo, useState } from 'react'
// import selectStyle from '../../design/selectStyle';
import Select from "react-select";
import countries from '../../../services/countries.json'
import Loader from '../../Layout/Loader';
import { toast } from 'react-toastify';
import { useAppContext } from '../../../AppContext';
import mainAxios from '../../../services/mainAxios';
import { useTranslation } from 'react-i18next';
import { contactTypesFn, getTcrList, tinTypes } from '../../../services/data';
import {  globalHandleChange, validateForm } from '../../../services/functions';
import currencies from '../../../services/currencies.json';
import selectStyle, { errorSelectStyle } from '../../../design/selectStyle';
import { TabPanel, TabView } from 'primereact/tabview';
import ContactBankAccounts from './ContactBankAccounts';
import DatePicker from 'react-datepicker';
import "./contacts.scss";
import IBAN from 'iban';


const EditAddContact = ({ onDataSuccess,cancelSupplier,errors:errorsAbove,contact:defContact={},id,fromInvoice,company:companyProp,...props  }) => {
  const [loading, setLoading] = useState(false)
  const [validationErrors, setValidationErrors] = useState({});
  const [pageLoading,setPageLoading]=useState(true)
  const [activeIndex, setActiveIndex] = useState(0);

  const defaultData = {
    name: '',
    idValue: "",
    nickname: '',
    address: '',
    phoneNumber: '',
    email: '',
    vendorCode: '',
    town: '',
    purchaseUnit: null,
    country2a: 'AL',
    country3a: "ALB",
    country: 'Albania',
    idType: "NUIS",
    currencyDefault: "ALL",
    customerDefault:false,
    contactTypes:[{
      type:"CUSTOMER",
    }],
    active:true,
  }
  const [contact, setContact] = useState({...defaultData,...defContact})
  const {
    user: [user],
    selectedCompany: [selectedCompany],
  } = useAppContext();


  // In the admin settings flow (/settings/contacts?companyId=...) the company is passed
  // in and must take precedence over the navbar-selected company.
  const company = companyProp ?? user?.companiesRights?.find(
    (company) => company.id === parseInt(selectedCompany)
);
  const companyId = company?.id ?? parseInt(selectedCompany);

  const connectionId = id ?id?.toString(): props?.match?.params?.id;

  const getContact=()=>{
    if(!connectionId) {
      setPageLoading(false)
      return
    }
    setPageLoading(true)
    mainAxios
      .post("apiEndpoint/search", {
        object: "GetConnections",
        params: {
          id: connectionId,
        },
        company: companyId,
      })
      .then((res) => {
        setPageLoading(false)
        if (res.data.status) {
          setContact({ ...(res?.data?.content?.[0] ?? {}),...defContact})
        }
      })
  }

  useEffect(() => {
    getContact()
  }, [connectionId]);

  // Sync validation errors from parent component (invoice validation)
  useEffect(() => {
    if (errorsAbove && Object.keys(errorsAbove).length > 0) {
      setValidationErrors(errorsAbove);
    }
  }, [errorsAbove]);

  const tcrList =useMemo(() => {
      return getTcrList(company)
  }, [selectedCompany, company?.id]);



  const handleChange = (e,currentKey,currentValue) => {
    let { name, value } = e?.target ?? {};

    globalHandleChange({key:currentKey??name,value:currentValue ?? value, setState:setContact})

  };

  const { t } = useTranslation("translations");
  const [sellerInputClass, setSellerInputClass] = useState("");
  const [inputClass, setInputClass] = React.useState("");

  const handleClientChange = (key, value, length, searchInput = false) => {
    value = length !== undefined ? value.slice(0, length) : value;
    if (searchInput && inputClass.length > 0) setInputClass("");
    

    setContact((prevData) => {
      const updatedData = { ...prevData, [key]: value };

      let selectedCountry;
      if (key === "country") {
        selectedCountry = countries.find((country) => country.label === value);
      } else if (key === "country2a") {
        selectedCountry = countries.find((country) => country.shorterCode === value);
      } else if (key === "country3a") {
        selectedCountry = countries.find((country) => country.shortCode === value);
      }

      if (selectedCountry) {
        updatedData.country = selectedCountry.label;
        updatedData.country2a = selectedCountry.shorterCode;
        updatedData.country3a = selectedCountry.shortCode;
      }
  
      return updatedData;
    });
  };

  const handleSellerTaxPayerSearch = () => {
    let buyerNipt = contact.idValue.split(" ").join("");
    if (
      buyerNipt &&
      !new RegExp("[a-zA-Z]{1}[0-9]{8}[a-zA-Z]{1}").test(buyerNipt)
    ) {
      toast.error(t(["toast.incorrectNipt"]), { containerId: "all_toast" });
      setSellerInputClass("error");
      return;
    }

    setSellerInputClass("loading");
    mainAxios
      .post("apiEndpoint/search", {
        object: "GetTaxpayersRequest",
        value: buyerNipt,
        nuis: company?.nuis,
      })
      .then((res) => {
        const content = res.data.content;
        if (res?.data?.status === true) {
          if (content.length === 0) {
            toast.warning(t(["toast.noTaxPayer"]), {
              containerId: "all_toast",
            });
            setSellerInputClass("error");
          } else {
            const clientData = content[0];

            setContact((prevData) => ({
              ...prevData,
              idValue: clientData?.tin ?? (contact?.idValue),
              name: clientData.name,
              address: clientData.address,
              country: clientData.country,
            }));

            setSellerInputClass("success");
          }
        } else {
          setSellerInputClass("error");
        }
      })
      .catch((e) => {
        setSellerInputClass("error");
      });
  };

const valid = ({ validateOnlyBankAcc = false } = {}) => {
  let validateFields = [
    {
      value: "accounts",
      label: "Accounts",
      optional: true,
      fields: [
        { value: "financialInstitution", label: "Financial Institution" },
        { value: "iban", label: "Iban", message: "Iban is not valid", validation: (iban) => IBAN.isValid(iban) },
        { value: "currency", label: "Currency" },
      ]
    }
  ];

  if (!validateOnlyBankAcc) {
    validateFields = validateFields.concat([
      { value: "name", label: "Name" },
      { value: "town", label: "Town" },
      { value: "country", label: "Country" },
      { value: "idType", label: "Id Type" },
      { value: "idValue", label: "Id Value" },
      { value: "address", label: "Address" },
      { value: "contactTypes", label: "Contact Types" }
    ]);
  }
  const validationObj = validateForm(validateFields, contact);
  let errors = { ...validationObj.errors };

  if (contact.accounts && contact.accounts.length > 0 && !validateOnlyBankAcc) {
    const ibans = contact.accounts.map(account => account.iban).filter(Boolean);
    const duplicateIbans = ibans.filter((iban, index) => ibans.indexOf(iban) !== index);
    if (duplicateIbans.length > 0) {
      contact.accounts.forEach((account, index) => {
        if (duplicateIbans.includes(account.iban)) {
          errors[`accounts.${index}.iban`] = {
            message: t("mySuppliers.duplicteIbanNotAllowed"),
            isCustom: true
          };
        }
      });
    }

    const checkDefault = contact.accounts.some(acc=>acc.defaultValue)
    if(!checkDefault){
       errors[`accounts.default`] = {
          message: "Default Bank Accunt is Required",
      };
    }
  }

  if (!validationObj.isValid || Object.keys(errors).length > 0) {
    setValidationErrors(errors);
    return false;
  }

  return true;
};


  
  const handleSaveChanges = ({saveInInvocieOnly=false,showToast=true}={}) => {
    if (!valid()) {
      if(showToast){
      toast.error(t("common.fixValidations"),{
        containerId: "all_toast",
      });
      }

      return;
    }
    const nuis = company?.nuis;

    if (!nuis) {
      toast.error("Nuis not found.");
      return;
    }

    const isUpdating = contact.id !== undefined;
    if(saveInInvocieOnly){
      onDataSuccess(contact)
      return 
    }
    setLoading(true)

    mainAxios
      .post(`/apiEndpoint/saveOrUpdate`, {
        object: "Connections",
        nuis: nuis,
        username: user.username,
        content: {
          ...contact,
          company: Number(companyId),
        },
      })
      .then((response) => {
        setLoading(false)
        if (response.data.status) {
          if (isUpdating) {
            toast.success(t(["mySuppliers.updateContact"]), {
              containerId: "all_toast",
            });
          } else {
            toast.success(t(["mySuppliers.newContact"]), {
              containerId: "all_toast",
            });
          }
          onDataSuccess(response.data.content[0])
        } else {
          toast.error(response.data.message || "Failed to save contact. Please try again.");
        }
      })
  };

  const contactTypeOptions = useCallback(()=>contactTypesFn(t),[t])

  const isEmployee = useMemo(()=>contact?.contactTypes?.find(ct=>ct.type==="EMPLOYEE"),[contact?.contactTypes])
  
  const tabErrors= useMemo(()=>{
    const errors = {};
    if (validationErrors.contactTypes || validationErrors?.name || validationErrors?.idType || validationErrors?.idValue || validationErrors?.town || validationErrors?.country || validationErrors?.address) {
      errors.baseInfo = true;
    }
    if (validationErrors?.customerCode) {
      errors.sales = true;
    }
    if (validationErrors.vendorCode || validationErrors.purchaseUnit) {
      errors.purchase = true;
    }

    if( Object.keys(validationErrors).some(key => /^accounts/.test(key))) {
      errors.bankAccounts = true;
    }

    return errors
  },[validationErrors])

  if(pageLoading) return <Loader/>

  const content = (
        <>
          <div className="row align-items-start my-2">
            <div className="form-group col-12" style={{marginBottom:"10px"}}>
              <div className="col-8 p-0 pr-2">

              <label htmlFor="purchaseUnit">{t("mySuppliers.contactName")}</label>
              <span className="text-danger"> *</span>
              <input
                type="text"
                id="name"
                name="name"
                className={`form-control  ${validationErrors.name ? "is-invalid" : ""}`}
                value={contact.name}
                onChange={handleChange}
              />
              {validationErrors.name && (
                <span className="text-danger">{t('validateSuppliers.name')}</span>
              )}
              </div>
            </div>
            <div className={`form-group col-md-4`}>
              <label htmlFor="purchaseUnit">{t("mySuppliers.contactType")}</label>
              <span className="text-danger"> *</span>
              <Select
                menuPlacement="auto"
                styles={validationErrors?.contactTypes ? errorSelectStyle : selectStyle}
                isMulti
                options={contactTypeOptions(t)}
                value={
                  contact?.contactTypes
                }
                isSearchable={true}
                getOptionLabel={(option) => option.type}
                getOptionValue={(option) => option.type}
                onChange={(opts) =>{
                  const parsedOptions = opts?.map(({type})=>({type})) ?? []
                  handleClientChange(
                    "contactTypes",
                    parsedOptions
                  )
                }
                }
                placeholder={t("invoice.select")}
                inactive={true}
              />
            </div>
            <div className="form-group col-md-4">
              <label htmlFor="idType">{t('mySuppliers.identityType')}</label>
              <span className="text-danger"> *</span>
              <Select
                menuPlacement="auto"
                styles={validationErrors?.idType? errorSelectStyle:selectStyle}
                options={tinTypes}
                value={
                  tinTypes?.find((idType) => idType?.label === contact?.idType) || null
                }
                onChange={(idType) =>
                  handleClientChange("idType", idType?.label)
                }
                placeholder={t("invoice.select")}
                name="idType"
              />
              {validationErrors.idType == 'ID' && <span className='text-danger'>{t('validateSuppliers.idType')}</span>}
            </div>

            <div className="form-group col-md-4">
              {contact.idType === "NUIS" ? (
                <>
                  <label className="form-label">
                    (NIPT)
                    <span className="text-danger"> *</span>
                  </label>
                  <div className="input-group position-relative">
                    <input
                      name="idValue"
                      type="text"
                      className={`form-control  required ${(sellerInputClass === "error" || validationErrors?.idValue)
                          ? "border-danger"
                          : sellerInputClass === "success"
                            ? "border-success"
                            : ""
                        }`}
                      value={contact.idValue}
                      onChange={(e) =>
                        handleClientChange("idValue", e.target.value, 100, true)
                      }
                    />
                    <div className="input-group-append">
                      <span
                        className="input-group-text cursor-pointer"
                        onClick={handleSellerTaxPayerSearch}
                      >
                        <FontAwesomeIcon icon={faSearch} />
                      </span>
                    </div>
                    {sellerInputClass === "loading" && (
                      <div className="input-icon input-loader">
                        <Loader size="xs" />
                      </div>
                    )}
                    {sellerInputClass === "error" && (
                      <div className="input-icon text-danger">
                        <FontAwesomeIcon icon={faTimes} />
                      </div>
                    )}
                    {sellerInputClass === "success" && (
                      <div className="input-icon text-success">
                        <FontAwesomeIcon icon={faCheck} />
                      </div>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <label htmlFor="idValue">{contact.idType ?? "Nipt"}</label>
                  {contact.idType == 'ID' && <span className="text-danger"> *</span>}
                  <input
                    type="text"
                    id="idValue"
                    name="idValue"
                    className={`form-control  ${validationErrors.idValue ? "is-invalid" : ""}`}
                    value={contact.idValue}
                    onChange={handleChange}
                  />
                </>
              )}
              {validationErrors.idValue && <span className='text-danger'>{t('validateSuppliers.idValue')}</span>}

            </div>

            <div className="form-group col-md-4">
              <label htmlFor="nickname">{t("mySuppliers.nickName")}</label>
              <input
                type="text"
                id="nickname"
                name="nickname"
                className="form-control"
                value={contact.nickname}
                onChange={handleChange}
              />
            </div>

           <div className="form-group col-md-4">
              <label htmlFor="phoneNumber">{t("users.phone")}</label>
              <input
                type="text"
                id="phoneNumber"
                name="phoneNumber"
                className="form-control "
                value={contact.phoneNumber}
                onChange={handleChange}
              />
            </div>

            <div className="form-group col-md-4">
              <label htmlFor="email">{t("email.email")}</label>
              <input
                type="email"
                id="email"
                name="email"
                className="form-control "
                value={contact.email}
                onChange={handleChange}
              />
            </div>



            {/* Country */}
            <div className="form-group col-md-4">
              <label htmlFor="country">{t("customers.country")}</label>
              <span className="text-danger"> *</span>
              <Select
                menuPlacement="auto"
                styles={selectStyle}
                options={countries}
                value={countries.find((country) => country.label === contact.country)}
                isSearchable={true}
                onChange={(selectedOption) =>
                  handleClientChange("country", selectedOption.label)
                }
                placeholder={t("invoice.select")}
                name="country"
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
              />
              {validationErrors.country && (
                <span className="text-danger">{t('validateSuppliers.country')}</span>
              )}
            </div>
           {/* Town */}
            <div className="form-group col-md-4">
              <label htmlFor="town">{t("customers.town")}</label>
              <span className="text-danger"> *</span>
              <input
                type="text"
                id="town"
                name="town"
                className={`form-control  ${validationErrors.town ? "is-invalid" : ""}`}
                value={contact.town}
                onChange={handleChange}
              />
              {validationErrors.town && <span className="text-danger">{t('validateSuppliers.town')}</span>}
            </div>
            <div className="form-group col-md-12">
              <label htmlFor="address">{t("customers.address")}</label>
              <span className="text-danger"> *</span>
              <textarea
                rows={1}
                type="text"
                id="address"
                name="address"
                placeholder='Address *'
                className={`form-control  ${validationErrors.address ? "is-invalid" : ""}`}
                value={contact.address}
                onChange={handleChange}
              />
            {validationErrors.address && (
                <span className="text-danger">{t('validateSuppliers.address')}</span>
              )}
            </div>
            {id && <div className="d-flex align-items-center pl-1 pt-1">
                <div className="form-group custom-control custom-checkbox mr-sm-2" style={{zIndex:0}}>
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="contactActive"
                    name="contactActive"
                    checked={contact?.active}
                    onChange={(e) =>
                      handleClientChange("active", e.target.checked)
                    }
                  />
                  <label
                    style={{ paddingTop: "3px", paddingLeft: "2px" }}
                    htmlFor="contactActive"
                    className="custom-control-label"
                  >
                  {t("company.active")}
                  </label>
                </div>
            </div>}
          </div>
          <TabView style={{marginTop:15}} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} >
            <TabPanel header={<div style={tabErrors?.sales ? { color: "red",borderBottom:"red" } : {}}>{t("mySuppliers.sales")}</div>}>
              <div className="row align-items-end mt-2">
                <div className="form-group col-md-6">
                  <label htmlFor="customerCode">Customer Code</label>
                  <input
                    type="text"
                    id="customerCode"
                    name="customerCode"
                    className={`form-control ${validationErrors.customerCode ? "is-invalid" : ""}`}
                    value={contact.customerCode}
                    onChange={handleChange}
                  />
                {validationErrors.customerCode && (
                    <span className="text-danger">Customer code is required </span>
                  )}
                </div>
                <div className="form-group col-md-6">
                  <label htmlFor="purchaseUnit">{t("mySuppliers.currencyDefault")}</label>
                  <Select
                    menuPlacement="auto"
                    styles={selectStyle}
                    options={currencies}
                    value={
                      currencies?.find(
                        (currency) =>
                          currency?.value === contact?.currencyDefault
                      ) ?? ""
                    }
                    isSearchable={true}
                    onChange={(currency) =>
                      handleClientChange(
                        "currencyDefault",
                        currency.value
                      )
                    }
                    placeholder={t("invoice.select")}
                  />
                </div>
                <div className="form-group custom-control custom-checkbox mr-sm-2 ml-3" style={{zIndex:0}}>
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="contactDefault"
                    name="contactDefault"
                    checked={contact?.customerDefault}
                    onChange={(e) =>
                      handleClientChange("customerDefault", e.target.checked)
                    }
                  />
                  <label
                    style={{ paddingTop: "2px", paddingLeft: "2px" }}
                    htmlFor="contactDefault"
                    className="custom-control-label"
                  >
                  Default Contact
                  </label>
                </div>
              </div>
            </TabPanel>
            <TabPanel header={<div style={tabErrors?.purchase ? { color: "red",borderBottom:"red" } : {}}>{t("mySuppliers.purchase")}</div>}>
              <div className="row align-items-end mt-2">
                  <div className="form-group col-md-6">
                    <label htmlFor="vendorCode">Vendor Code</label>
                    <input
                      type="text"
                      id="vendorCode"
                      name="vendorCode"
                      className="form-control "
                      value={contact.vendorCode}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group col-md-6">
                    <label htmlFor="purchaseUnit">{t("purchases.purchaseUnit")}</label>
                    <Select
                      menuPlacement="auto"
                      styles={selectStyle}
                      options={tcrList}
                      value={
                        tcrList?.find(
                          (purchaseUnit) =>
                            purchaseUnit?.value === contact?.purchaseUnit
                        ) ?? ""
                      }
                      isSearchable={true}
                      onChange={(purchaseUnit) =>
                        handleClientChange(
                          "purchaseUnit",
                          purchaseUnit.value
                        )
                      }
                      placeholder={t("invoice.select")}
                      name="purchaseUnit"
                    />
                  </div>
              </div>
            </TabPanel>
            <TabPanel header={<div style={tabErrors?.bankAccounts ? { color: "red",borderBottom:"red" } : {}}>{t("mySuppliers.banksAccountsInfo")}</div>}>
              <ContactBankAccounts 
                onSucess={()=>{getContact()}}
                setContact={setContact}
                contact={contact}
                companyId={companyId}
                validationErrors={validationErrors}
                valid={valid}
                setValidationErrors={setValidationErrors}
              />
            </TabPanel>
            {isEmployee && <TabPanel header={<div style={tabErrors?.employee ? { color: "red",borderBottom:"red" } : {}}>{t("mySuppliers.employee")}</div>}>
              <div className="row mt-2">
                  <div className="form-group col-md-6">
                    <label htmlFor="position">Job Position</label>
                    <input
                      type="text"
                      id="position"
                      name="position"
                      className="form-control "
                      value={contact.position}
                      onChange={handleChange}
                    />
                </div>
                  <div className="form-group col-md-6">
                    <label htmlFor="fatherName">Father's Name</label>
                    <input
                      type="text"
                      id="fatherName"
                      name="fatherName"
                      className="form-control"
                      value={contact.fatherName}
                      onChange={handleChange}
                    />
                </div>
                  <div className="form-group col-md-6">
                      <label >
                        Birthday
                      </label>
                      <DatePicker
                        selected={contact.birthday}
                        dateFormat="dd/MM/yyyy"
                        name="dueDate"
                        autoComplete="off"
                        showDisabledMonthNavigation
                        onChange={(date)=>handleChange(null,"birthday",date)}
                        customInput={
                          <input
                            className={`form-control ${
                              validationErrors?.birthday && "is-invalid"
                            }`}
                          />
                        }
                      />
                </div>
              </div>
            </TabPanel>}
            <TabPanel header={t("mySuppliers.otherInfo")}>
                <div className="form-group col-md-12 mt-2">
                  <label htmlFor="nickname">Notes</label>
                  <textarea
                    rows={4}
                    id="notes"
                    type="text"
                    maxLength={200}
                    name="notes"
                    value={contact?.notes}
                    onChange={handleChange}
                    className="form-control"
                  />
              </div>
            </TabPanel>
          </TabView>
        </>


  );
console.log({contact})

  const footer = (
    <div className='d-flex gap-2 mt-4'>
        {fromInvoice && <button className="btn btn-outline-primary mr-2 mt-3" onClick={() => handleSaveChanges({saveInInvocieOnly:true})} >
          {loading ? (
            <Loader size="xs" color="white" />
          ) : (
            <>
            <FontAwesomeIcon icon={faFileInvoice} className="mr-2" />
              {t("invoice.saveInIvoice")}
            </>
          )}
      </button>}
        <button className="btn btn-primary mr-2 mt-3" onClick={handleSaveChanges} >
          {loading ? (
            <Loader size="xs" color="white" />
          ) : (
            <>
            <FontAwesomeIcon icon={faFileInvoice} className="mr-2" />
            {fromInvoice?t("invoice.saveInSystem"):t("common.save")}
            </>
          )}
      </button>
    </div>
  )

  return (
    <div className="contacts mt-3 px-3">
        {content}
      {footer}
    </div>
  )
}

export default EditAddContact